import { render, staticRenderFns } from "./PackageTypes.vue?vue&type=template&id=af2b8c4e&scoped=true&"
import script from "./PackageTypes.vue?vue&type=script&lang=js&"
export * from "./PackageTypes.vue?vue&type=script&lang=js&"
import style0 from "./PackageTypes.vue?vue&type=style&index=0&id=af2b8c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2b8c4e",
  null
  
)

export default component.exports